<template>
  <View gap="md" direction="column">
    <Text variant="h3">Activity feed</Text>

    <View v-if="isPending" justify="center" padding-block="lg">
      <LoadingIndicator />
    </View>

    <Text v-else-if="items.length === 0" variant="body-medium" color="tertiary">
      Activity for this renter will appear here.
    </Text>

    <ActivityFeedList v-else :items="items" />
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { LoadingIndicator, Text, View } from '@tallo/design-system';
import { ActivityFeedList, useRenterActivityFeedQuery } from '@tallo/investor/activity-feed';

const { data, isPending } = useRenterActivityFeedQuery();
const items = computed(() => data.value || []);
</script>
